import type { ReactElement } from "react";

import type { IconName } from "@similarweb/icons";

import type { IShareUser } from "app/sharing/SharingService";

export enum AssetName {
    Dashboard = "Dashboard",
    KeywordLists = "Keyword lists",
}

export interface IEmptyStateProps {
    userWebsite?: string;
    marginBottom?: number;
}

export interface IPredefinedAssetTemplate {
    title: string | ReactElement;
    content: ReactElement;
    onClick: () => void;
    buttonText: string;
    hoverText?: string;
}

export interface IDashboardItem {
    addedTime: string;
    id: string;
    name: string;
    owner?: IShareUser;
}

export interface IKeywordListItem {
    addedTime: string;
    id: string;
    name: string;
    keywords: string[];
    owner?: IShareUser;
}

interface IAssetProps {
    lastSeen: string | undefined;
    type: AssetName;
    onClick: () => void;
    hoverFooter?: ReactElement;
}

export interface IAssetsContainerProps<T> {
    assets: Array<T>;
    columns: number;
}

export interface IAssetCreationItem {
    iconName: IconName;
    onClick: () => void;
    text: string;
    tooltipContent: ReactElement;
}

export const enum AssetType {
    DASHBOARD = "Dashboard",
    KEYWORD_LIST = "KeywordList",
}

export interface ILastViewedItem {
    assetId: string;
    assetType: AssetType;
    lastViewed: string;
}

export interface IDashboardAsset extends IDashboardItem, IAssetProps {}
export interface IKeywordListAsset extends IKeywordListItem, IAssetProps {}
export type AssetItem = IDashboardItem | IKeywordListItem;
export type AssetProps = IDashboardAsset | IKeywordListAsset;
